module.exports = __webpack_public_path__ + "img/jkjddialog.fc521851.jpg";